import { Box } from '@chakra-ui/react';
import { every, isEmpty } from 'lodash';
import { useDeliveryMethods, useOrganizationPreference } from '@melio/platform-api';

import { Loader } from '@/cl/components/Loader/Loader.component';
import { SettingsSectionContainer } from '@/cl/components/SettingsSectionContainer/SettingsSectionContainer.component';
import { useActiveScreen } from '@/hooks/useActiveScreen';
import { useIsMsnDashboardDisplay } from '@/hooks/useIsMsnDashboardDisplay.hooks';
import { ActiveFlowEnum, ScreensEnum } from '@/store/app/app.types';
import { usePlatformIntl } from '@/translations/Intl';
import { SectionHeaderWithButton } from '@/widgets/settings-page/Common/SectionHeaderWithButton.widget';
import { CreditCardFeePayment } from '@/widgets/settings-page/ReceivingMethodsPage/CreditCardFeePayment.widget';
import { ReceivingMethodsSettingsPage } from '@/widgets/settings-page/ReceivingMethodsPage/ReceivingMethodsSettingsPage.widget';

export const ReceivingMethods = () => {
  useActiveScreen(ScreensEnum.settings, ActiveFlowEnum.receivingMethods);
  const { data: deliveryMethods, isLoading: isDeliveryMethodsLoading } = useDeliveryMethods({ isGetOwn: true });
  const { data: isVendorAbsorbedFee, isLoading: isOrganizationPreferenceLoading } = useOrganizationPreference({
    id: 'isVendorAbsorbedFee',
  });
  const isLoading = isDeliveryMethodsLoading || isOrganizationPreferenceLoading;
  const hasVerifiedDeliveryMethod = !every(deliveryMethods, ['details.verifiedStatus', 'not-verified']);

  const { formatMessage } = usePlatformIntl();

  const isMSNPortalVendor = useIsMsnDashboardDisplay();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box>
      <SettingsSectionContainer data-component="ProfileSettingsComponent">
        <SectionHeaderWithButton title={formatMessage('app.settings.BillingSection.cards.receivingMethods.title')} />
        <ReceivingMethodsSettingsPage deliveryMethods={deliveryMethods} />
      </SettingsSectionContainer>
      {!isMSNPortalVendor && !isEmpty(deliveryMethods) && (
        <Box mt={8}>
          <SettingsSectionContainer>
            <SectionHeaderWithButton
              title={formatMessage('widgets.receivingMethodsSettings.creditCardFeePayment.title')}
            />
            <CreditCardFeePayment
              disabled={!hasVerifiedDeliveryMethod}
              isVendorAbsorbedFee={isVendorAbsorbedFee?.value}
            />
          </SettingsSectionContainer>
        </Box>
      )}
    </Box>
  );
};
